/*
 * @Author: 刘小博
 * @Date: 2023-02-15 17:23:29
 * @LastEditTime: 2023-02-17 18:19:21
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\agreement-manage\system-settings\modules\systemSettingRouter.js
 * 系统设置
 */
const systemSettingRouter = [
  // 协议管理  系统配置 操作日志
  {
    path: '/protocolManagement/setting/log',
    name: 'protocolManagementSettingLog',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/protocolManagement/setting/log.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '操作日志',
    },
  },
  // 协议管理  系统配置
  {
    path: '/protocolManagement/setting',
    name: 'protocolManagementSetting',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/protocolManagement/setting/index.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '系统配置',
    },
  },

  // 协议管理  系统配置 年度协议内容配置
  {
    path: '/protocolManagement/setting/agreement-config',
    name: 'protocolManagementSettingAgreementConfig',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/protocolManagement/setting/AgreementConfig.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '年度协议内容配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'protocolManagementSetting',
        },
      ],
    },
  },
  // 协议管理  系统配置 年度协议内容配置 操作日志
  {
    path: '/protocolManagement/setting/config-log',
    name: 'protocolManagementSettingConfigLog',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/protocolManagement/setting/configLog.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '操作日志',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'protocolManagementSetting',
        },
        {
          title: '年度协议内容配置',
          name: 'protocolManagementSettingAgreementConfig',
        },
      ],
    },
  },
  // 协议管理  系统配置 年度协议内容配置 协议自定义内容
  {
    path: '/protocolManagement/setting/custom-template/:agreement_order/:agreement_main/:id',
    name: 'protocolManagementSettingCustomTemplate',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/protocolManagement/setting/customTemplate.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'protocolManagementSetting',
        },
        {
          title: '年度协议内容配置',
          name: 'protocolManagementSettingAgreementConfig',
        },
      ],
    },
  },
]
export default systemSettingRouter
